import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetCarrierParameterCommand extends IRequestCommand<
  IGetCarrierParameterResponse,
  ErrorDetails,
  IGetCarrierParameterCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierUserId}/parameter?key={key}';
  public override setParameters(parameters: IGetCarrierParameterCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace('{key}', parameters.key);
  }
}

export interface IGetCarrierParameterCommandParameters
  extends ICommandParameters {
  carrierUserId: string;
  key: string;
}

export interface IGetCarrierParameterResponse extends ICommandResponse {}
